// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f88d07f7","453":"94315750","455":"7586c542","885":"cd0762fb","977":"d2613375"}[chunkId] + ".chunk.js";
};